/**
 * Channel-filter state updates that keep the SAME array when nothing changes.
 * Report fetches depend on the selection array, so returning a new but equal
 * array (e.g. `prev.filter(...)` on load) would re-run the whole report.
 */

/** Drop selected values that are no longer offered; same array if none were. */
export const retainAvailableSelection = (prev, options) => {
  const next = prev.filter((value) => options.includes(value));
  return next.length === prev.length ? prev : next;
};

/** Clear the selection; same array if it is already empty. */
export const clearSelection = (prev) => (prev.length ? [] : prev);
